export const kataviAccommodation = [
  {
    name: 'Katavi Safari Lodge',
    rating: 4,
    distance: '2.5 km from venue',
    description: 'Luxury lodge with modern amenities, perfect for conference attendees',
    cost: '150,000',
    costLabel: 'per night',
    amenities: ['Airport Shuttle', 'Conference Facilities', 'Restaurant', 'Swimming Pool', 'Free WiFi'],
    phone: '+255 755 123 456',
    email: 'reservations@katavisafari.com',
    website: 'https://www.katavisafari.com/',
    bookSubject: 'TDA Conference 2026 Reservation',
  },
  {
    name: 'Mpanda Grand Hotel',
    rating: 4,
    distance: '5 km from venue',
    description: 'Comfortable hotel with excellent service and convenient location',
    cost: '120,000',
    costLabel: 'per night',
    amenities: ['24/7 Reception', 'Parking', 'Bar', 'Restaurant', 'Free WiFi'],
    phone: '+255 754 234 567',
    email: 'info@mpandagrand.com',
    website: 'https://www.mpandagrand.com/',
    bookSubject: 'TDA Conference 2026 Reservation',
  },
  {
    name: 'Katavi Conference Centre Hotel',
    rating: 3,
    distance: '0.5 km from venue',
    description: 'Convenient location right next to the conference venue',
    cost: '100,000',
    costLabel: 'per night',
    amenities: ['Parking', 'Conference Room Access', 'Restaurant', 'Free WiFi'],
    phone: '+255 753 345 678',
    email: 'bookings@kataviconference.com',
    website: 'https://www.kataviconference.com/',
    bookSubject: 'TDA Conference 2026 Reservation',
  },
  {
    name: 'Wildlife View Resort',
    rating: 4,
    distance: '8 km from venue',
    description: 'Scenic resort offering a peaceful retreat after conference sessions',
    cost: '180,000',
    costLabel: 'per night',
    amenities: ['Shuttle Service', 'Nature Views', 'Restaurant', 'Spa', 'Swimming Pool', 'Free WiFi'],
    phone: '+255 752 456 789',
    email: 'info@wildlifeview.com',
    website: 'https://www.wildlifeview.com/',
    bookSubject: 'TDA Conference 2026 Reservation',
  },
  {
    name: 'Katavi Budget Inn',
    rating: 3,
    distance: '3 km from venue',
    description: 'Affordable accommodation with basic amenities',
    cost: '60,000',
    costLabel: 'per night',
    amenities: ['Parking', 'Restaurant', 'Free WiFi'],
    phone: '+255 751 567 890',
    email: 'reservations@katavibudget.com',
    website: 'https://www.katavibudget.com/',
    bookSubject: 'TDA Conference 2026 Reservation',
  },
  {
    name: 'Mpanda City Hotel',
    rating: 3,
    distance: '6 km from venue',
    description: 'Modern hotel in the city center with easy access to amenities',
    cost: '90,000',
    costLabel: 'per night',
    amenities: ['Fitness Center', 'Parking', 'Bar', 'Restaurant', 'Free WiFi'],
    phone: '+255 750 678 901',
    email: 'info@mpandacity.com',
    website: 'https://www.mpandacity.com/',
    bookSubject: 'TDA Conference 2026 Reservation',
  },
];
